/* REKALMA theme JS */
(function(){
'use strict';
var FREE_SHIP_CENTS=5500;

/* Cada bloque de abajo se inicializa dentro de safe(). Antes iba todo en un
   unico IIFE: un fallo en las opiniones o en el manifiesto rompia el resto del
   fichero y el carrito dejaba de funcionar sin que nada lo dijera. */
function safe(nombre,fn){
  try{fn();}catch(err){
    if(window.console&&console.warn)console.warn('[REKALMA] fallo en '+nombre,err);
  }
}

/* Aceptacion de condiciones: al marcar la casilla se sella la hora en el
   atributo oculto, que viaja con el pedido y queda como prueba. */
document.addEventListener('change',function(e){
  var box=e.target.closest&&e.target.closest('.acepta-box');
  if(!box)return;
  var form=box.closest('form');if(!form)return;
  var campo=form.querySelector('.acepta-attr');if(!campo)return;
  campo.value=box.checked?('Si · '+new Date().toISOString()):'';
});
var fmt=function(cents){return (cents/100).toFixed(2).replace('.',',')+' €';};

/* toast */
var toastT;
window.rkToast=function(msg){var t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('on');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('on');},2600);};

/* header hide/show */
var hdr=document.getElementById('hdr'),lastY=0;
if(hdr)addEventListener('scroll',function(){
  var y=scrollY,drawer=document.getElementById('drawer');
  hdr.classList.toggle('line',y>8);
  hdr.classList.toggle('hide',y>90&&y>lastY&&!(drawer&&drawer.classList.contains('on')));
  lastY=y;
},{passive:true});

/* mobile menu */
var mMenu=document.getElementById('mMenu');
var burger=document.getElementById('burger'),mClose=document.getElementById('mClose');
if(burger&&mMenu)burger.onclick=function(){mMenu.classList.add('open');};
if(mClose&&mMenu)mClose.onclick=function(){mMenu.classList.remove('open');};
if(mMenu)mMenu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mMenu.classList.remove('open');});});

/* reveals */
safe('reveals',function(){
  /* Sin IntersectionObserver el contenido se queda en opacity:0 para siempre.
     Antes de nada, la red de seguridad: si no existe, se muestra todo. */
  if(!('IntersectionObserver' in window)){
    document.querySelectorAll('.rv').forEach(function(el){el.classList.add('on');});
    var h0=document.getElementById('hero');if(h0)h0.classList.add('on');
    return;
  }
  var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('on');io.unobserve(x.target);}});},{threshold:.15});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});

  /* El titular del hero esta en opacity:0 / translateY hasta que la seccion
     recibe .on. Esto colgaba del evento 'load', que espera a TODAS las imagenes
     y scripts de la pagina: el elemento LCP no se pintaba hasta el final.
     Ahora se destapa en cuanto hay primer frame. */
  var hero=document.getElementById('hero');
  if(hero)requestAnimationFrame(function(){requestAnimationFrame(function(){hero.classList.add('on');});});
});

/* accordions */
document.querySelectorAll('.faq-q,.acc-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var it=btn.parentElement,a=it.querySelector('.faq-a,.acc-a'),open=it.classList.toggle('open');
    if(a)a.style.maxHeight=open?a.scrollHeight+'px':'0';
  });
});

/* manifiesto scroll-lit */
safe('manifiesto',function(){
var mani=document.getElementById('mani');
if(mani){
  mani.innerHTML=mani.textContent.trim().split(/\s+/).map(function(w){
    return w.charAt(0)==='^'?'<span class="acc">'+w.slice(1)+'</span>':'<span>'+w+'</span>';
  }).join(' ');
  var mSpans=mani.querySelectorAll('span');
  var maniScroll=function(){
    var r=mani.getBoundingClientRect();
    var p=Math.min(1,Math.max(0,(innerHeight*.88-r.top)/(r.height+innerHeight*.42)));
    var n=Math.round(p*mSpans.length);
    mSpans.forEach(function(s,i){s.classList.toggle('lit',i<n);});
  };
  addEventListener('scroll',maniScroll,{passive:true});maniScroll();
}
});

/* sistema 3 fases */
safe('sistema',function(){
var sysPanels=Array.prototype.slice.call(document.querySelectorAll('.sys-p'));
if(sysPanels.length){
  var sysArts=Array.prototype.slice.call(document.querySelectorAll('#sysArt svg'));
  var sysNum=document.getElementById('sysNum'),sysBig=document.getElementById('sysBig');
  var sio=new IntersectionObserver(function(es){es.forEach(function(x){
    if(!x.isIntersecting)return;
    var i=sysPanels.indexOf(x.target);
    sysPanels.forEach(function(p,j){p.classList.toggle('act',j===i);});
    sysArts.forEach(function(a,j){a.classList.toggle('act',j===i);});
    if(sysNum)sysNum.textContent='0'+(i+1);
    if(sysBig)sysBig.textContent='0'+(i+1);
  });},{rootMargin:'-42% 0px -42% 0px',threshold:0});
  sysPanels.forEach(function(p){sio.observe(p);});
}
});

/* contadores */
safe('contadores',function(){
var fmtN=function(n){return (''+n).replace(/\B(?=(\d{3})+(?!\d))/g,'.');};
var cio=new IntersectionObserver(function(es){es.forEach(function(x){
  if(!x.isIntersecting)return;cio.unobserve(x.target);
  var el=x.target,t=+el.dataset.t,d=1400,s0=performance.now();
  /* Si el dato no es numerico (p.ej. "7-12"), animarlo escribia NaN en pantalla. */
  if(isNaN(t)){el.textContent=el.dataset.t||el.textContent;return;}
  (function tick(now){var p=Math.min(1,(now-s0)/d);el.textContent=fmtN(Math.round(t*(1-Math.pow(1-p,3))));if(p<1)requestAnimationFrame(tick);})(s0);
});},{threshold:.6});
document.querySelectorAll('.ctr').forEach(function(c){cio.observe(c);});
});

/* quotes */
safe('opiniones',function(){
var qBox=document.getElementById('qBox');
var qDataEl=document.getElementById('qData');
if(qBox&&qDataEl){
  var quotes=JSON.parse(qDataEl.textContent);
  /* Seccion sin bloques: sin esta salida, renderQuote(0) leia undefined.t y
     el error tumbaba todo el JS posterior, carrito incluido. */
  if(!quotes.length){qBox.closest('section').style.display='none';return;}
  var qi=0;
  var renderQuote=function(i,instant){
    var r=quotes[i];
    var paint=function(){
      document.getElementById('qText').textContent='"'+r.t+'"';
      document.getElementById('qName').textContent=r.n;
      document.getElementById('qMeta').textContent=r.m;
      document.getElementById('qAv').textContent=r.n.split(' ').map(function(x){return x[0];}).join('');
      document.getElementById('qIdx').textContent='0'+(i+1)+' / 0'+quotes.length;
    };
    if(instant){paint();return;}
    qBox.classList.add('out');setTimeout(function(){paint();qBox.classList.remove('out');},450);
  };
  var nextQ=function(){qi=(qi+1)%quotes.length;renderQuote(qi);};
  var qT=setInterval(nextQ,7000);
  var resetQT=function(){clearInterval(qT);qT=setInterval(nextQ,7000);};
  var qPrev=document.getElementById('qPrev'),qNext=document.getElementById('qNext');
  if(qPrev)qPrev.onclick=function(){qi=(qi-1+quotes.length)%quotes.length;renderQuote(qi);resetQT();};
  if(qNext)qNext.onclick=function(){qi=(qi+1)%quotes.length;renderQuote(qi);resetQT();};
  renderQuote(0,true);
}
});

/* ── CART (Shopify AJAX API) ── */
var drawer=document.getElementById('drawer'),veil=document.getElementById('veil');
function openDrawer(){if(drawer){drawer.classList.add('on');veil.classList.add('on');}}
function closeDrawer(){if(drawer){drawer.classList.remove('on');veil.classList.remove('on');}}
window.rkOpenDrawer=openDrawer;
var cartBtn=document.getElementById('cartBtn');
if(cartBtn)cartBtn.addEventListener('click',function(e){e.preventDefault();refreshCart().then(openDrawer);});
var drClose=document.getElementById('drClose');
if(drClose)drClose.onclick=closeDrawer;
if(veil)veil.onclick=closeDrawer;

function renderCart(cart){
  var badge=document.getElementById('badge');
  if(badge){badge.textContent=cart.item_count;badge.classList.toggle('on',cart.item_count>0);}
  var box=document.getElementById('drItems');
  if(!box)return;
  if(!cart.item_count){box.innerHTML='<p class="dr-empty">Tu carrito está vacío.</p>';}
  else{
    var html=cart.items.map(function(it){
      var img=it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x$1$2')+'" alt="">':'';
      return '<div class="dr-i"><div class="dr-i-media">'+img+'</div>'+
      '<div class="dr-i-b"><h4>'+it.product_title+'</h4><p class="pr">'+fmt(it.final_price)+'</p>'+
      '<div class="qty"><button data-q="'+it.key+'|'+(it.quantity-1)+'">−</button><span>'+it.quantity+'</span><button data-q="'+it.key+'|'+(it.quantity+1)+'">+</button></div></div>'+
      '<button class="rmv" data-q="'+it.key+'|0">Eliminar</button></div>';
    }).join('');
    var upsell=document.getElementById('drUpsellData');
    if(upsell){
      var sug=null;
      try{sug=JSON.parse(upsell.textContent).find(function(s){return !cart.items.some(function(it){return it.product_id===s.pid;});});}catch(e){}
      if(sug){
        var simg=sug.img?'<img src="'+sug.img+'" alt="">':'';
        html+='<div class="dr-up"><h5>Completa tu ritual</h5><div class="dr-up-i"><div class="dr-i-media">'+simg+'</div><div class="b"><b>'+sug.title+'</b><span>'+fmt(sug.price)+'</span></div><button data-addv="'+sug.vid+'">Añadir</button></div></div>';
      }
    }
    box.innerHTML=html;
  }
  var t=cart.total_price;
  var tot=document.getElementById('drTot');if(tot)tot.textContent=fmt(t);
  var bar=document.getElementById('shipBar');if(bar)bar.style.width=Math.min(100,t/FREE_SHIP_CENTS*100)+'%';
  var msg=document.getElementById('shipMsg');
  if(msg)msg.innerHTML=t>=FREE_SHIP_CENTS?'<b>Envío gratis desbloqueado.</b>':'Te faltan <b>'+fmt(FREE_SHIP_CENTS-t)+'</b> para el envío gratis.';
}
function refreshCart(){return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){renderCart(c);return c;});}
window.rkAdd=function(items,msg){
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(function(r){if(!r.ok)throw r;return r.json();})
  .then(function(){return refreshCart();})
  .then(function(){openDrawer();window.rkToast(msg||'Añadido al carrito');})
  .catch(function(){window.rkToast('No se pudo añadir — revisa el stock');});
};
document.addEventListener('click',function(e){
  var q=e.target.closest('[data-q]');
  if(q){var parts=q.dataset.q.split('|');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parts[0],quantity:+parts[1]})})
    .then(function(r){if(!r.ok)throw r;return r.json();}).then(renderCart)
    /* Antes fallaba en silencio: el cliente pulsaba +/- y no pasaba nada. */
    .catch(function(){window.rkToast('No se pudo actualizar el carrito');});return;}
  var av=e.target.closest('[data-addv]');
  if(av){window.rkAdd([{id:+av.dataset.addv,quantity:1}]);return;}
});
/* Shopify cachea el HTML, asi que el contador del carrito puede llegar viejo y
   hay que refrescarlo con /cart.js. Pero no compitiendo con el primer pintado:
   se hace cuando el navegador queda libre. */
if(window.requestIdleCallback)requestIdleCallback(function(){refreshCart();},{timeout:2500});
else setTimeout(function(){refreshCart();},1200);

/* ── PDP ── */
safe('ficha de producto',function(){
var pform=document.getElementById('pForm');
if(pform){
  pform.addEventListener('submit',function(e){
    e.preventDefault();
    var vid=+pform.querySelector('[name="id"]').value;
    window.rkAdd([{id:vid,quantity:1}]);
  });
  /* delivery estimate */
  var shipEl=document.getElementById('shipEst');
  /* Solo se promete fecha si el producto está disponible: antes escribía
     "En stock" encima aunque la variante estuviese agotada. */
  if(shipEl&&shipEl.dataset.disponible==='1'){
    var DW=['dom','lun','mar','mié','jue','vie','sáb'],DM=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    var df=function(d){return DW[d.getDay()]+' '+d.getDate()+' '+DM[d.getMonth()];};
    var e1=new Date(Date.now()+7*864e5),e2=new Date(Date.now()+12*864e5);
    shipEl.innerHTML='En stock · Pídelo hoy y recíbelo entre el <b>'+df(e1)+'</b> y el <b>'+df(e2)+'</b>';
  }
  /* fbt */
  var fbtBox=document.getElementById('fbt');
  if(fbtBox){
    var basePrice=+fbtBox.dataset.baseprice,baseVid=+fbtBox.dataset.basevid;
    var upd=function(){
      var checks=Array.prototype.slice.call(fbtBox.querySelectorAll('[data-fbt]:checked'));
      var t=basePrice,n=1,vids=[baseVid];
      checks.forEach(function(c){t+=+c.dataset.price;n++;vids.push(+c.dataset.fbt);});
      document.getElementById('fbtTot').textContent=fmt(t);
      document.getElementById('fbtFree').textContent=t>=FREE_SHIP_CENTS?'Envío gratis incluido':'A '+fmt(FREE_SHIP_CENTS-t)+' del envío gratis';
      document.getElementById('fbtAdd').textContent='Añadir '+n+(n>1?' productos':' producto');
      fbtBox.dataset.sel=vids.join(',');
    };
    fbtBox.querySelectorAll('[data-fbt]').forEach(function(c){c.onchange=upd;});
    document.getElementById('fbtAdd').onclick=function(){
      var items=fbtBox.dataset.sel.split(',').map(function(v){return{id:+v,quantity:1};});
      window.rkAdd(items,'Combo añadido al carrito');
    };
    upd();
  }
  /* sticky ATC */
  var satc=document.getElementById('satc'),cta=document.querySelector('.pdp-cta');
  if(satc&&cta){
    var satcAdd=document.getElementById('satcAdd');
    if(satcAdd)satcAdd.onclick=function(){var vid=+pform.querySelector('[name="id"]').value;window.rkAdd([{id:vid,quantity:1}]);};
    new IntersectionObserver(function(es){es.forEach(function(x){
      satc.classList.toggle('on',!x.isIntersecting&&x.boundingClientRect.top<0);
    });},{threshold:0}).observe(cta);
  }
}
});

/* editor de temas: recargar la vista previa al re-renderizar secciones para reinicializar el JS */
if(window.Shopify&&window.Shopify.designMode){
  document.addEventListener('shopify:section:load',function(){location.reload();});
}
})();
